import { SimpleTradeCompanyListItem } from 'api';
import { TradeCompanyAutocomplete, useFormContext } from 'form';
import { useContext } from 'react';
import { SectionContainer } from 'ui';

import { SalesOrderFormContext } from '../../contexts/SalesOrderFormContext';

export const BuyerPartiesSection = () => {
  const { setValue } = useFormContext();
  const { defaultValues, variant } = useContext(SalesOrderFormContext);
  const onPurchaseChange = (tradeCompany: SimpleTradeCompanyListItem) => {
    if (tradeCompany.currency) {
      setValue('buyer_currency', tradeCompany.currency);
      setValue('third_party_commission_currency', tradeCompany.currency);
    }
  };

  return (
    <SectionContainer title="Parties">
      <TradeCompanyAutocomplete
        name="purchaser_id"
        label="Purchaser"
        onlyBuyers={true}
        excludeKycBanned
        required
        onSelectOption={onPurchaseChange}
        defaultValue={defaultValues?.purchaser_id}
        infoTooltip="Company that agrees to purchase the material from Safi."
      />
      <TradeCompanyAutocomplete
        name="buyer_agent_id"
        label="Buyer agent"
        defaultValue={defaultValues?.buyer_agent_id ?? undefined}
        onlyBuyers={true}
        excludeKycBanned
        infoTooltip="Company or person who facilitated the transaction between Safi and the purchaser. "
      />
      <TradeCompanyAutocomplete
        name="end_processor_id"
        label="End processor"
        onlyBuyers={true}
        excludeKycBanned
        required
        defaultValue={defaultValues?.end_processor_id}
        infoTooltip="Company that processes the material. "
      />
      {variant === 'update' ? (
        <TradeCompanyAutocomplete
          name="consignee_id"
          label="Consignee"
          onlyBuyers={true}
          excludeKycBanned
          required
          defaultValue={defaultValues?.consignee_id}
        />
      ) : null}
    </SectionContainer>
  );
};
